<template>
	<AppLayout :title="trans('rotations.requests.title')">
		<Empty v-if="rotationRequests.data.length === 0"/>
		<template v-else>
			<Pagination :resource="rotationRequests"/>
			<CardGrid>
				<RotationRequestComponent v-for="request in rotationRequests.data" :key="`period-request-${request.id}`" :request="request"/>
			</CardGrid>
			<Pagination :resource="rotationRequests"/>
		</template>
	</AppLayout>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, type Ref, ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Pagination from '@/Components/UI/Pagination.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import {type PaginatedModel} from '@/Types/Pagination/PaginatedModel'
import {type RotationRequest} from '@/Types/Periods/Rotations/RotationRequest'
import RotationRequestComponent from '@/Components/Association/Representatives/RotationRequest.vue'

const props = defineProps<{
	rotationRequests:PaginatedModel<RotationRequest>,
}>()

const rotationRequests:Ref<PaginatedModel<RotationRequest>> = ref(props.rotationRequests)
</script>